exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1uT_u{margin:0;padding-right:6px;border-bottom:1px solid #d3d3d3}._1uT_u,.B25pO{color:grey;font-family:Helvetica}.B25pO{margin-top:-30px;z-index:0;font-size:1.2rem}", ""]);

// exports
exports.locals = {
	"zipTextField": "_1uT_u",
	"floater": "B25pO"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"module":true,"modules":true,"localIdentName":"[hash:base64:5]"}!../node_modules/sass-loader/lib/loader.js?{"outputStyle":"collapsed","sourceMap":true,"includePaths":["/Users/markromero/Code/frn-platform-frontend/src"]}!./routes/Checkout/components/NewBillingZipForm/styles.scss
// module id = 1087
// module chunks = 0